<template>
  <div v-if="order && meta_item.sell_info && meta_item.sell_info.currency">
    <UiModal :open="status_poppad_open" @close="status_poppad_open = false">
      
      <!-- <div v-if="status_ajaxing_get_order" class="p-5 tac">
        <span class="ui-loading-icon"></span>
      </div> -->

      <!-- step: pad_init -->
      <div v-if="on_step === 'pad_init'" class="px-5 pt-5 pb-4">
        <h3 class="tac mb-4">
          {{lg('',{
            en: 'Order Summary',
            zh: '订单详情',
          })}}
        </h3>

        <div class="mb-2">
          <span>
            {{lg('',{
              en:  'Price',
              zh:  '价格',
            })}}
          </span>
          <span class="float-right">
            {{meta_item.sell_info.buyValue | tofixed6}}
            {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == meta_item.sell_info.currency).names )}}
          </span>
        </div>

        <hr>

        <div class="mb-2">
          <span>
            {{lg('',{
              en:'Your Wallet Balance',
              zh:'钱包余额',
            })}}
          </span>
          <span class="float-right">
            {{balance_current_token | tofixed3 | qfw}}
            {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == meta_item.sell_info.currency).names )}}
          </span>
        </div>

        <div class="mb-2">
          <span>
            {{lg('',{
              en:'Service Fee',
              zh:'服务费',
            })}}
          </span>
          <span class="float-right">2.5%</span>
        </div>
        
        <div class="mb-2">
          <span>
            {{lg('',{
              en:'Total Cost',
              zh:'总费用',
            })}}
          </span>
          <span class="float-right">
            <b class="c">
              {{meta_item.sell_info.buyValue * 1.025 | tofixed6}}
              {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == meta_item.sell_info.currency).names )}}
            </b>
            <span class="t-gray">
              (${{meta_item.sell_info.buyValue* 1.025 | tokenToUsd(meta_item.sell_info.currency)}} 
              {{lg('',{
                en: 'USD',
                zh: '美元',
              })}})
            </span>
          </span>
        </div>

        <div class="d-flex justify-content-center align-items-center" style="height:100px;">

          <span v-if="status_ajaxing_check_approve || status_ajaxing_approve || status_ajaxing_buy" class="ui-loading-icon"></span>

          <button 
            :class="['btn btn-primary btn-round']"
            style="min-width: 120px;"
            v-else-if="!status_approved_current_token"
            @click="actionApproveCurrentToken()"
            >
            Approve
          </button>

          <button 
            v-else
            :class="['btn btn-primary btn-round']"
            style="min-width: 120px;"
            :disabled="status_ajaxing_get_order || !order "
            @click="actionBuy()"
            >
            {{lg('buy')}}
          </button>
        </div>
      </div>

      <!-- step: done -->
      <div v-if="on_step === 'pad_done'" class="px-5 pt-5">
        <h3 class="tac mb-2">
          {{lg('',{
            en:  'Congratulations',
            zh:  '恭喜您！购买成功',
          })}}
        </h3>
        <div class="mb-4 tac">
          {{lg('',{
            en:  'You successfully purchased',
            zh:  '你成功买下了',
          })}}
          <br>
          <b>
            {{item.name}}
          </b>
        </div>

        <div class="pic-holder mb-4">
          <!-- <img :src="item.image" style="height: 200px;"> -->
          <CpNftCoverImg
            style="height: 200px;"
            :src="item.image"
          />
        </div>

        <div class="mb-3">
          <div>
            <span>
              {{lg('',{
                en: 'Status',
                zh: '交易阶段',
              })}}
            </span>
            <span class="float-right">
              {{lg('',{
                en: 'Processing',
                zh: '还在交易',
              })}}
            </span>
          </div>
          <div>
            <span>
              {{lg('',{
                en: 'Transaction hash',
                zh: '交易记录',
              })}}
            </span>
            <span class="float-right">
              <a :href="$store.state.sitecfg.url_transaction_view+tx" target="_blank">
                <u>
                  {{tx | shortAddress}}
                </u>
              </a>
            </span>
          </div>
        </div>

        <div v-if="status_poppad_open">
          <BlockShareLinks :share_title="text_share_title"/>
        </div>
      </div>

    </UiModal>
  </div>
</template>

<script>
// import { OrderSide } from 'opensea-js/lib/types'
import bus from '@/bus.js'
import {mapActions} from 'vuex'
import BlockShareLinks from './block_share_links.vue'

export default {
  name: 'popBuy',
  components: {
    BlockShareLinks,
  },
  props: [
    'item',
    'meta_item',
    'cfg_status_poppad',
  ],
  data() {
    return {
      on_step: 'pad_init',

      status_poppad_open: false,

      status_approved_current_token: false,
      status_ajaxing_approve: false,
      status_ajaxing_check_approve: false,

      // 
      order: null,
      status_ajaxing_get_order: false,

      // 
      status_ajaxing_buy: false,

      tx: '',
    }
  },
  computed: {
    text_share_title(){
      let v = this
      let mark = `Hey everyone, check this out. ${v.item.name} . #JGNdefi #BSC #Collectible #NFT`
      // 暂无中文翻译
      // if(v.$store.state.app.lang == 'zh'){
      //   mark = `Hey everyone, check this out. ${v.item.name}. #JGNdefi #BSC #Collectible #NFT`
      // }
      return mark
    },
    balance_current_token(){
      let item = this.$store.state.web3.account_wallet.find(item => item.id === this.meta_item.sell_info.currency)
      return !item ? '-' :item.num
    },
  },
  watch: {
    'cfg_status_poppad'(val){
      if(val){
        this.runPop()
      }
    },
    'status_poppad_open'(val){
      if(!val){
        this.$parent.btnToggleBuy(false)
      }
    }
  },
  methods: {
    ...mapActions([
      'buyNFT',
      'hasApproveUSDT',
      'approveUSDT',
      'hasApproveAXIS',
      'approveAXIS',
      'hasApproveCake',
      'approveCake',
    ]),

    async getOrders(){
      let v = this

      v.order = v.meta_item.sell_info
    },

    async actionBuy(){
      let v = this

      console.log(v.order);
      let obj = {
        address: v.$store.state.web3.account,
        address_owner: v.order.address,
        token_address: v.order.nft_address,
        token_id: v.order.nft_id,
        salt: v.order.salt,
        signature: v.order.signature,
        buyValue: v.order.buyValue,
        currency: v.order.currency,
        type: v.meta_item.type,

        callHookOnBuy: function(){
          v.status_ajaxing_buy = true
        },
        callback: function(){
          v.on_step = 'pad_done'
          setTimeout(function(){
            v.uniGetWalletBalance()
            v.$parent.run()
          },1000)
        },
        callbackOnErr: function(){
          v.status_ajaxing_buy = false
        },

      }

      let res_hash = await v.buyNFT(obj)
      v.tx = res_hash
    },

    // async actionBuy_backup(){
    //   let v = this
    //   let address_my = v.$store.state.web3.account
    //   await v.buyNFT(address_my)
    // },

    async actionApproveCurrentToken(){
      let v = this
      let token_type = v.meta_item.sell_info.currency
      // let address_my = v.$store.state.web3.account
      
      if(token_type === 'usdt'){
        v.status_ajaxing_approve = true
        await v.approveUSDT({
          callback: function(){
            v.status_approved_current_token = true
            v.status_ajaxing_approve = false
          },
          callbackOnErr: function(){
            v.status_ajaxing_approve = false
          },
        })
      }

      if(token_type === 'axis'){
        v.status_ajaxing_approve = true
        await v.approveAXIS({
          callback: function(){
            v.status_approved_current_token = true
            v.status_ajaxing_approve = false
          },
          callbackOnErr: function(){
            v.status_ajaxing_approve = false
          },
        })
      }

      if(token_type === 'cake'){
        v.status_ajaxing_approve = true
        await v.approveCake({
          callback: function(){
            v.status_approved_current_token = true
            v.status_ajaxing_approve = false
          },
          callbackOnErr: function(){
            v.status_ajaxing_approve = false
          },
        })
      }
    },

    async checkApprove(){
      let v = this
      let token_type = v.meta_item.sell_info.currency
      let address_my = v.$store.state.web3.account

      if(!token_type || !address_my){
        return
      }

      v.status_ajaxing_check_approve = true

      if(token_type === 'eth'){
        v.status_approved_current_token = true
      }
      
      // check usdt
      if(token_type === 'usdt'){
        let mark = await v.hasApproveUSDT(address_my)
        console.log('check approve: '+token_type+'-'+mark)
        v.status_approved_current_token = mark
      }

      // check axis
      if(token_type === 'axis'){
        let mark = await v.hasApproveAXIS(address_my)
        console.log('check approve: '+token_type+'-'+mark)
        v.status_approved_current_token = mark
      }

      // check cake
      if(token_type === 'cake'){
        let mark = await v.hasApproveCake(address_my)
        console.log('check approve: '+token_type+'-'+mark)
        v.status_approved_current_token = mark
      }

      v.status_ajaxing_check_approve = false
    },

    // run pop
    runPop(){
      let v = this

      v.on_step = 'pad_init'
      // v.on_step = 'pad_done'
      v.status_ajaxing_buy = false
      v.status_ajaxing_approve = false

      let address_my = v.$store.state.web3.account
      if(!address_my){
        // connect wallet
        bus.headervue.modalOpen = true
        this.$parent.btnToggleBuy(false)
        return
      }

      v.status_poppad_open = v.cfg_status_poppad

      //
      v.getOrders()
      
      // check approve
      v.status_ajaxing_check_approve = false
      if(!v.status_approved_current_token){
        v.checkApprove()
      }
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>